import { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { AlmaceniaLogo } from "../components/Brand";
import { useHistory, useLocation } from "react-router-dom";

export default function Dashboard({ tabs = [] }) {
    const history = useHistory();
    const location = useLocation();
    const tabIds = useMemo(() => tabs.map((tab) => tab.id), [tabs]);
    const getTabFromQuery = () => {
        const query = new URLSearchParams(location.search);
        const tab = query.get("tab");
        return tabIds.includes(tab) ? tab : null;
    };
    const [activeTab, setActiveTab] = useState(getTabFromQuery() || tabs[0]?.id || null);
    const activeContent = tabs.find((tab) => tab.id === activeTab)?.content;

    useEffect(() => {
        const tabFromQuery = getTabFromQuery();
        if (tabFromQuery && tabFromQuery !== activeTab) {
            setActiveTab(tabFromQuery);
        }
        if (!tabFromQuery && tabs[0]?.id && activeTab !== tabs[0].id) {
            setActiveTab(tabs[0].id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search, tabIds.join(","), tabs.length]);

    const handleTabChange = (tabId) => {
        const selectedTab = tabs.find((tab) => tab.id === tabId);
        if (selectedTab?.onClick && !selectedTab?.content) {
            selectedTab.onClick();
            return;
        }

        setActiveTab(tabId);
        const query = new URLSearchParams(location.search);
        query.set("tab", tabId);
        history.replace({ pathname: location.pathname, search: query.toString() });
    };

    return (
        <Layout>
            <Sidebar>
                <BrandDesktop>
                    <AlmaceniaLogo variant="black" width="220px" height="42px" />
                </BrandDesktop>

                {tabs.map((tab) => (
                    <TabButton
                        key={tab.id}
                        $active={activeTab === tab.id}
                        onClick={() => handleTabChange(tab.id)}
                    >
                        <TabMain>
                            {tab.icon && <TabIcon>{tab.icon}</TabIcon>}
                            <span>{tab.label}</span>
                        </TabMain>
                        {tab.trailingIcon && <TrailingIcon src={tab.trailingIcon} alt="" aria-hidden="true" />}
                    </TabButton>
                ))}
            </Sidebar>

            <Content>
                {activeContent || <h2>Selecciona una opción</h2>}
            </Content>
        </Layout>
    );
}

/* ========== ESTILOS ========== */

const Layout = styled.div`
  display: flex;
  height: 100vh;
  font-family: "Poppins", sans-serif;
  background: #fff;
  color: #000;
`;

const Sidebar = styled.aside`
  width: 240px;
  background: #fff;
  border-right: 1px solid #eaeaea;
  padding: 1.5rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const BrandDesktop = styled.div`
  padding: 20px;
`;

const TabButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
  padding: 0.8rem 1rem;
  background: #fff;
  border: ${(p) => (p.$active ? "1px solid #000" : "1px solid transparent")};
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  color: ${(p) => (p.$active ? "#000" : "#666")};
  text-align: left;
  font-weight: ${(p) => (p.$active ? "bold" : "normal")};
  transition: background 0.2s, color 0.2s, border 0.2s;
  outline: 0!important;

  &:hover {
    border: 1px solid #000;
    color: #000;
  }
`;

const TabIcon = styled.span`
  display: flex;
  align-items: center;
  font-size: 1.2rem;
`;

const TabMain = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  min-width: 0;
`;

const TrailingIcon = styled.img`
  width: 16px;
  height: 16px;
  display: block;
  flex-shrink: 0;
`;

const Content = styled.main`
  flex: 1;
  padding: 2rem;
  overflow-y: auto;
`;
